export default __webpack_public_path__ + "static/hugh-dennis-f5e3ec16e5e3e0000f94980fa80264d0.png";